  <h4 class="heading-3 mt-3 mb-2 top-75px page-heading">
    <span class="color-grey-700">{{mls.languageText.community.key1}}</span>
  </h4>
  <div class="row" *ngIf="!showPublicCommunityList">
    <div class="col-md-3 col-12 mb-3">
    </div>
    <div class="col-md-89 col-12 mb-2 overflow-hidden back-btn"
      *ngIf="showBackButton">
      <span (click)="backButtonHandler()" class="cursor-pointer">
        <img src="assets/themes/icons/back-arrow.svg" alt="back icon" height="20px" class="mr-2 mb-1" />
        <span class="paragraph-bold"><span class="color-grey-700">{{mls.languageText.community.key28}}</span></span></span>
    </div>
  </div>
  <div class="row community-listing-container mb-4">
    <div class="col-md-3 col-12 mb-md-3">
      <app-create-community-card class="top-125"
        [showNoCommunity]="showNoCommunity"
        [setFilterAsAll]="filterKey"
        [translations]="communityListTranslation"
        (emitFilterKey)="setFilter($event)"
        (emitCommunityFilterKey)="setCommunityFilter($event)"
        (emitShowBackBtn)="onBackBtnEmit($event)"
        (emitPage)="setPage($event)"
        [currentPage]="page">
      </app-create-community-card>
      <ng-container *ngIf="isFiltersVisible">
        <app-search-filter
          [filterData]="filterData"
          (setFilter)="setFilter($event)"
          [selected_filter]="'community'">
        </app-search-filter>
      </ng-container>
    </div>
    <div class="col-md-9 col-12 pl-md-0 overflow-hidden">
      
      <ng-container *ngIf="showPublicCommunityList">
        <app-public-community-card
          (emitViewAll)="viewAllClicked($event);setFilter($event, false, true)"
          (emitCommunityDetail)="emitPublicCommunityDetail($event)"
          [community]="publicCommunityList[0]"
          [translations]="publicTranslations"
          [pOffset]="pOffset"
          [callingFrom]="callingFrom"
          (emitReloadCommunityList)="reloadAllCommunityList($event)">
        </app-public-community-card>
        <div class="separator-line mx-3"></div>
      </ng-container>
  
      <div *ngIf="!showNoCommunity"
        infiniteScroll
        [infiniteScrollDistance]="numbers.TWO"
        [infiniteScrollThrottle]="numbers.FIFTY"
        [infiniteScrollDisabled]="busyGettingData"
        (scrolled)="onScrollDown()"
        [scrollWindow]="scrollWindow.TRUE">
        <ng-container *ngFor="let communities of communityList">
          <app-community-card
            [communityDetails]="communities"
            [translations]="communityCardTranslation"
            (emitFilterKey)="viewAllClicked($event); viewAllHandler($event)"
            [offset]="offset"
            [showPublicCommunityList]="showPublicCommunityList">
            <ng-container *ngIf="!isListEnabled">
              <ng-container *ngFor="let community of communities.list| slice: numbers.ZERO: numbers.SIX; last as isLast">
                <app-community-list
                  [translations]="communityListTranslation"
                  [community]="community"
                  [isLast]="isLast"
                  [userId]="dss?.user_profile_data?.profile?.custom_id"
                  [callingFrom]="callingFrom"
                  (emitCommunityEdit)="emitCommunityEdit($event)"
                  (emitCommunityDetail)="emitCommunityDetail($event)"
                  (emitJoinPublicCommunity)="joinPublicCommunityHandler($event)">
                </app-community-list>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="isListEnabled">
              <ng-container *ngFor="let community of communities.list; last as isLast">
                <app-community-list
                  [translations]="communityListTranslation"
                  [community]="community"
                  [isLast]="isLast"
                  [cardView]="publicCommunityFullList"
                  [userId]="dss?.user_profile_data?.profile?.custom_id"
                  [callingFrom]="callingFrom"
                  (emitCommunityEdit)="emitCommunityEdit($event)"
                  (emitCommunityDetail)="emitCommunityDetail($event)"
                  (emitJoinPublicCommunity)="joinPublicCommunityHandler($event)"
                  (emitWithdrawRequest)="withdrawConfirmation($event)"
                  (emitReloadCommunityList)="reloadPublicCommunityList($event)">
                </app-community-list>
              </ng-container>
            </ng-container>
          </app-community-card>
        </ng-container>
      </div>
      <div *ngIf="showNoCommunity">
        <div
          class="bg-white container-shadow p-4 unverified-div d-flex flex-column align-items-center justify-content-center h-100 text-center">
          <img src="assets/themes/images/community-empty-placeholder.svg" alt="no community data" width="240" height="180" />
          <p class="pt-4 w-75 paragraph">
            {{mls.languageText.community.key11}}
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-12"></div>
  </div>
  
  <div
    *ngIf="fcs.publicCommunityMaxMemberCount$ | async"
    id="maxCommunityMemberCount"
    class="modal fade success-popup"
    tabindex="-1"
    role="dialog"
    [config]="{ show: true,backdrop: true }"
    (onHidden)="onHidden()"
    bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-md">
      <div class="modal-content">
          <div class="modal-header pt-4">
            <span class="text-right">
              <img src="assets/themes/icons/cancel.svg" 
                alt="Close icon" 
                class="cursor-pointer float-right"
                (click)="onHidden()" />
            </span>
          </div>
           <div class="modal-body">
               <div class="pt-0 px-3 pb-3 text-center ">
                <p></p>
                <span class="paragraph-bold">
                  {{mls.languageText.community.key73}}
                </span>
               </div>
           </div>
         </div>
   </div>
   </div>
  
   <ng-template #communityListTemplate>
    <app-community-list
      [translations]="communityListTranslation"
      [community]="community"
      [isLast]="isLast"
      [userId]="dss?.user_profile_data?.profile?.custom_id"
      [callingFrom]="callingFrom"
      (emitCommunityEdit)="emitCommunityEdit($event)"
      (emitCommunityDetail)="emitCommunityDetail($event)"
      (emitJoinPublicCommunity)="joinPublicCommunityHandler($event)">
    </app-community-list>
   </ng-template>
  
   <app-confirm-modal
    [isWithdrawRequestConfirmModalShown]="confirmationModal"
    [confirmationModalContent]="confirmationText"
    [getListItem]="confirmedCommunity"
    (resetConfirmModal)="resetConfirmModal()"
    (emitAllowAction)="allowAction($event)">
  </app-confirm-modal>